const returnToParamName = "r";
export const returnToUrlHandler = {
  decoratePath: (path: string, returnTo: string) => {
    const urlObj = new URL(path, window.location.origin);
    urlObj.searchParams.set(returnToParamName, returnTo);
    console.log("url", urlObj.toString());
    return `${urlObj.pathname}${urlObj.search}`;
  },
  getReturnToFromUrl: (path: string): string | undefined => {
    const urlObj = new URL(path, window.location.origin);
    const returnTo = urlObj.searchParams.get(returnToParamName);
    return returnTo ? decodeURIComponent(returnTo) : undefined;
  },
};
